// Gate for signed-in routes: waits for auth, sends signed-out visitors to /signup, and shows the
// maintenance page while maintenanceStatus/status.isActive is set.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//FIREBASE
import { auth, db } from '../../firebase';
import { doc, onSnapshot } from "firebase/firestore"; 

//FUNCTIONS
import { registerListener } from './ListenerManager';
import { rememberReturnPath } from './returnPath';

//IMPORT UI
import AppLoader from './AppLoader';
import MaintenancePage from '../miscComponents/MaintenancePage';



const PrivateRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMaintenanceActive, setIsMaintenanceActive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged(user => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        rememberReturnPath(window.location.pathname + window.location.search);
        navigate("/signup");
      }
      setIsLoading(false);
    });

    registerListener(unsubscribeAuth);

    const maintenanceStatusRef = doc(db, 'maintenanceStatus', 'status');
    const unsubscribeMaintenance = onSnapshot(maintenanceStatusRef, (statusSnapshot) => {
      if (statusSnapshot.exists()) {
        setIsMaintenanceActive(statusSnapshot.data().isActive);
      } else {
        setIsMaintenanceActive(false);
      }
    });

    registerListener(unsubscribeMaintenance);

    return () => {
      unsubscribeAuth();
      unsubscribeMaintenance();
    };
  }, [navigate]);

  if (isLoading) {
    return <AppLoader />;
  }

  if (isMaintenanceActive) {
    return <MaintenancePage />;
  }

  return isAuthenticated ? children : null;
};

export default PrivateRoute;
